export default __webpack_public_path__ + "static/media/IMG_7615.f9c4ca19.jpeg";